import MessagingProvider from './Messaging.provider';

export default MessagingProvider;